module.exports = __webpack_public_path__ + "img/spencer.f9356b02.jpeg";